import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomConfirmDialogService } from 'src/app/services/Non-Master/CustomConfirmDialog.service';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { AppSettings } from 'src/app/shared/AppSettings';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SystemDefaultModel, ChineseDefaultModel, EnglishDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { AppComponent } from 'src/app/app.component';
import { FormControl } from '@angular/forms';

import { tChartAccService } from 'src/app/services/tChartAcc.service';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';

import { DateTimeConvertService } from 'src/app/services/CommonService/DateTimeConvert.service';
import { tChartAccModel } from 'src/app/models/tChartAccModel';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-select-acc-code-dialog',
  templateUrl: './select-acc-code-dialog.component.html',
  styleUrls: ['./select-acc-code-dialog.component.css']
})
export class SelectAccCodeDialogComponent implements OnInit {

  groupType_selection: Array<any>;
  accBSPL_selection: Array<any>;
  accType_selection: Array<any>;
  accDrCr_selection: Array<any>;
  accAllowNegBal_selection: Array<any>;
  accDisable_selection: Array<any>;


  selectedRowIndex: number = -1;

  constructor(public activeModal: NgbActiveModal,
    private log: LoggerService,
    private tChartAccService: tChartAccService,
    private DateTimeConvertService: DateTimeConvertService) { }

  displayedColumns: string[] = [

    'accCode',
    // 'accName'
    'accType',

    'accDrCr',
    'accBSPL',

  ];

  dataSource: MatTableDataSource<tChartAccModel>;
  dataList: tChartAccModel[];
  private TAG = 'SelectBedNoDialogComponent';
  action_delete = MastersKeyStringValue.ACTION_DELETE;
  tableKeyValue = MastersKeyStringValue.TABLE_Bed;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  accCodeFilter = new FormControl();

  filteredValues = {
    accCode: ''
  };


  @Input() clthConsultNumber: string;


  ngOnInit() {

    this.setDefaultLanguageString(AppComponent.usingLanguage);

    this.getAllData();
  }

  getAllData(): void {
    // let dbToday = this.DateTimeConvertService.ConvertCurrentDBDay(new Date()).toString();

    this.tChartAccService.getAllData().subscribe(data => {

      this.dataList = data;
      this.dataSource = new MatTableDataSource<tChartAccModel>(data);
      this.dataSource.paginator = this.paginator;

      this.accCodeFilter.valueChanges.subscribe((value) => {
        this.filteredValues['accCode'] = value;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.dataSource.filterPredicate = this.customFilterPredicate();
      this.dataSource.sort = this.sort;

    });
  }


  setDefaultLanguageString(language: String){
    switch(language) {
      case SystemDefaultModel.Language_Chinese:
          this.groupType_selection = ChineseDefaultModel.groupTypeList;
          this.accBSPL_selection = ChineseDefaultModel.accBSPLList;
          this.accType_selection = ChineseDefaultModel.accTypeList;
          this.accDrCr_selection = ChineseDefaultModel.accDrCrList;
          this.accAllowNegBal_selection = ChineseDefaultModel.accAllowNegBalList;
          this.accDisable_selection = ChineseDefaultModel.accDisableList;
        break;
      case SystemDefaultModel.Language_English:
        this.groupType_selection = ChineseDefaultModel.groupTypeList;
        this.accBSPL_selection = ChineseDefaultModel.accBSPLList;
        this.accType_selection = ChineseDefaultModel.accTypeList;
        this.accDrCr_selection = ChineseDefaultModel.accDrCrList;
        this.accAllowNegBal_selection = ChineseDefaultModel.accAllowNegBalList;
        this.accDisable_selection = ChineseDefaultModel.accDisableList;
        break;
      default:
        this.groupType_selection = ChineseDefaultModel.groupTypeList;
        this.accBSPL_selection = ChineseDefaultModel.accBSPLList;
        this.accType_selection = ChineseDefaultModel.accTypeList;
        this.accDrCr_selection = ChineseDefaultModel.accDrCrList;
        this.accAllowNegBal_selection = ChineseDefaultModel.accAllowNegBalList;
        this.accDisable_selection = ChineseDefaultModel.accDisableList;
        break;
    }
  }


  customFilterPredicate() {
    const myFilterPredicate = (data: tChartAccModel, filter: string): boolean => {

      const searchString = JSON.parse(filter);

      return (searchString.bedDesc.toLowerCase() === '' ||
        (data.accCode != null && data.accCode.toString().trim().toLowerCase().indexOf(searchString.bedDesc.toLowerCase()) !== -1))
        ;
    }
    return myFilterPredicate;
  }


  selectRow(selectedModel: tChartAccModel, index: number) {

    this.log.i(this.TAG, 'selectRow');


    this.activeModal.close(selectedModel);
  }

  getAccTypeName(type: number){

    if (!isNullOrUndefined(this.accType_selection)){

      for (let i = 0; i < this.accType_selection.length; i++){
        if (this.accType_selection[i].value === type) {
          return this.accType_selection[i].displayName;
        }
      }

    }

    return '';

  }
}
